const supportedLngs = ['en', 'el'];
export const ni18nConfig = {
  supportedLngs,
  ns: ['handoverCars', 'buttons'],
  nsSeparator: '>',
  defaultLocale: 'en',
  fallbackLng: 'en',
  defaultLanguage: 'en',
};
